import React, { useState } from 'react';
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
import ButtonGroup from '../elements/ButtonGroup';
import Button from '../elements/Button';
import Image from '../elements/Image';
import Modal from '../elements/Modal';

const propTypes = {
    ...SectionProps.types
}

const defaultProps = {
    ...SectionProps.defaults
}

const Start = ({
    className,
    topOuterDivider,
    bottomOuterDivider,
    topDivider,
    bottomDivider,
    hasBgColor,
    invertColor,
    ...props
}) => {

    const [videoModalActive, setVideomodalactive] = useState(false);

    const openModal = (e) => {
        e.preventDefault();
        setVideomodalactive(true);
    }

    const closeModal = (e) => {
        e.preventDefault();
        setVideomodalactive(false);
    }

    const outerClasses = classNames(
        'hero section center-content',
        topOuterDivider && 'has-top-divider',
        bottomOuterDivider && 'has-bottom-divider',
        hasBgColor && 'has-bg-color',
        invertColor && 'invert-color',
        className
    );

    const innerClasses = classNames(
        'hero-inner section-inner',
        topDivider && 'has-top-divider',
        bottomDivider && 'has-bottom-divider'
    );

    return (
        <section
            {...props}
            className={outerClasses}
        >
            <div className="container">
                <div className={innerClasses}>
                    <div className="hero-content">
                        <h1 className="col-md-7 col-12 mt-0 mb-16 reveal-from-bottom hero-title" data-reveal-delay="200">
                            GeoPortal Corporación Autónoma Regional para la Defensa de la Meseta de Bucaramanga
                        </h1>
                        <div className="col-md-6 col-12 hero-description">
                            <p className="mb-20 reveal-from-bottom" data-reveal-delay="400">
                                Herramienta de consulta y análisis de información cartográfica básica y temática, en materia de ambiente, recursos naturales renovables y cambio climático
                            </p>
                            <div className="reveal-from-bottom d-flex" data-reveal-delay="600">
                                <ButtonGroup>
                                    <Button className="fw-normal" tag="a" target="_blank" color="primary"
                                        wideMobile href="http://www.cdmb.gov.co/web/">
                                        Más información
                                    </Button>
                                </ButtonGroup>
                            </div>
                        </div>
                    </div>
                    <div className="hero-figure reveal-from-bottom illustration-element-01" data-reveal-value="20px" data-reveal-delay="800">
                        <a
                            data-video="https://www.youtube.com/watch?v=UZZMpCLrIFc"
                            href="#0"
                            aria-controls="video-modal"
                            onClick={openModal}
                        >
                            <Image
                                className=""
                                src={require('./../../assets/images/portatil_video.png')}
                                alt="Start"
                                width={596}
                                height={504} />
                        </a>
                    </div>
                    <Modal
                        id="video-modal"
                        show={videoModalActive}
                        handleClose={closeModal}
                        video="https://www.youtube.com/embed/UZZMpCLrIFc"
                        videoTag="iframe" />
                </div>
            </div>
        </section>
    );
}

Start.propTypes = propTypes;
Start.defaultProps = defaultProps;

export default Start;